import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';
import { ConfigName, selectConfigString, updateConfigString } from '../common/config';
import { sqlConnectionProvider, storage } from '../sqlConnectionProvider';

// This upgrade reverses version0001 and most of the data out of the native key/value storage
// and back into the SQLite database.

const upgrade = async () => {
  logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0002');
  const versionString = await sqlConnectionProvider.storageGet(ConfigName.Version);
  const version = parseInt(versionString || '0');
  if (version === 1) {
    await updateAndDeleteItem(ConfigName.IsAuthenticated);
    await updateAndDeleteItem(ConfigName.Technician);
    await updateAndDeleteItem(ConfigName.SelectedUsername);
    await updateAndDeleteItem(ConfigName.SelectedCompany);
    await updateAndDeleteItem(ConfigName.SelectedDatabase);
    await updateAndDeleteItem(ConfigName.AuthToken);
    await updateAndDeleteItem(ConfigName.SettingsIsDarkMode);
    await updateAndDeleteItem(ConfigName.SettingsEnableOfflineMode);
    await updateAndDeleteItem(ConfigName.SettingsGpsServicesUserEnabled);
    await updateAndDeleteItem(ConfigName.SettingsScheduledEndTime);
    await updateAndDeleteItem(ConfigName.FilterMenuSelectedBranchCode);
    await updateAndDeleteItem(ConfigName.FilterMenuTechCodeCheckbox);
    await updateAndDeleteItem(ConfigName.FilterMenuTodaysBookingsCheckbox);
    await updateAndDeleteItem(ConfigName.FilterMenuOrderByDateDescending);
    await updateAndDeleteItem(ConfigName.ClockingRequestQueue);
    await updateAndDeleteItem(ConfigName.TechCommentRequestQueue);
    await updateAndDeleteItem(ConfigName.VehicleAttachmentRequestQueue);
    await updateAndDeleteItem(ConfigName.Technician);
    await updateAndDeleteItem(ConfigName.LabourClocking);
    await updateAndDeleteItem(ConfigName.AttendanceClocking);
    await updateAndDeleteItem(ConfigName.ServerClockingDetail);
    await updateAndDeleteItem(ConfigName.SelectedRepairOrder);
    await updateAndDeleteItem(ConfigName.AccuracyList);
    await updateAndDeleteItem(ConfigName.LocationsRaw);
    await updateAndDeleteItem(ConfigName.DistanceRaw);
    await updateAndDeleteItem(ConfigName.DistanceAccurate);
    await updateAndDeleteItem(ConfigName.SelectedWorkshopVehicle);
    await updateAndDeleteItem(ConfigName.SelectedWorkshopVehicle);
    await updateAndDeleteItem(ConfigName.SelectedStockUnit);
    await updateAndDeleteItem(ConfigName.SelectedTechComments);
    await updateAndDeleteItem(ConfigName.AdhocTechCommentsCache);
    await updateAndDeleteItem(ConfigName.SelectedVehicleAttachments);
    await updateAndDeleteItem(ConfigName.SelectedVehicleAttachments);
    await updateAndDeleteItem(ConfigName.AdhocAttachmentsCache);
    await updateAndDeleteItem(ConfigName.AdhocVehicleAttachmentsCache);
    await updateAndDeleteItem(ConfigName.SelectedClockingHistory);

    await sqlConnectionProvider.storageSet(ConfigName.Version, '2');
    await sqlConnectionProvider.storageRemove(ConfigName.TransactionLog);
  } else {
    logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0002 not required');
  }
};

const updateAndDeleteItem = async (config: ConfigName) => {
  try {
    const item = await selectConfigString(config, true);
    if ((item || '').length) {
      await updateConfigString(config, item, false);
      await deleteConfig(config);
    }
  } catch (ex) {
    logTransaction(LogType.Internal, `[SQLITE]: Failed to upgrade ${config}. ${ex}`);
  }
};

const deleteConfig = async (config: ConfigName) => {
  storage?.remove(config);
};

export default upgrade;
